import Entity from '../entity'

export default class Country extends Entity<number>{
    zone_id: number;
    name: string;
    iso_code: string;
    code: string;
    active: boolean;
}


